import { createTheme } from '@material-ui/core/styles'
import { theme } from 'Assets/Styles/theme'
import getMuiTheme from 'material-ui/styles/getMuiTheme'

export const muiTheme = getMuiTheme({
  palette: {
    secondary: { main: theme.colors.primary },
  },
  datePicker: {
    calendarTextColor: theme.colors.secondary,
    headerColor: theme.colors.primary,
    selectColor: theme.colors.primary,
    textColor: theme.colors.white,
  },
  timePicker: {
    calendarTextColor: theme.colors.secondary,
    headerColor: theme.colors.primary,
    selectColor: theme.colors.primary,
    accentColor: theme.colors.primary,
    textColor: theme.colors.white,
  },
  flatButton: {
    primaryTextColor: theme.colors.primary,
  },
})

export const muiTheme4 = createTheme({
  palette: {
    primary: { main: theme.colors.primary },
    secondary: { main: theme.colors.secondary },
  },
  typography: {
    fontFamily: 'Proxima Nova',
  },
  overrides: {
    MuiTypography: {
      root: {
        //it looks for the --font-family by default, but that could affect other parts of the website
        fontFamily: 'Proxima Nova !important',
      },
    },
    MuiLinearProgress: {
      root: {
        height: 6,
      },
    },
  },
})
